module.exports = __webpack_public_path__ + "img/frequentTargetNodes.379d0739.png";